import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import Icon from '../../Icons';
import './style.scss';

const FormikSelectClear = ({
  abbr,
  customOption,
  defaultValue,
  delayHide,
  delayShow,
  direction,
  error,
  helpText,
  isDisabled,
  label,
  margin,
  name,
  options,
  tooltipText,
  touched,
  value,
  setFieldTouched,
  labelClass,
  isHidden,
  isArial = false,
  noOptionsMessage = 'No hay opciones',
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Form.Group
      controlId={label}
      className={`${isDisabled ? 'disabled' : ''} ${margin} ${error && touched ? 'is-invalid' : ''} ${
        isHidden ? 'd-none' : ''
      }`}
    >
      {label && (
        <Form.Label className={`d-flex align-items-center ${labelClass}`}>
          <span className={`${isArial ? 'arial-dt' : ''}`}>{label}</span>{' '}
          {abbr && <abbr className="text-danger ml-1">*</abbr>}
          {tooltipText && (
            <ButtonToolbar className="ml-2">
              <OverlayTrigger
                key={direction}
                placement={direction}
                delay={{ show: delayShow, hide: delayHide }}
                overlay={<Tooltip>{tooltipText}</Tooltip>}
              >
                <Icon icon="help-circle" height="15px" width="15px" />
              </OverlayTrigger>
            </ButtonToolbar>
          )}
        </Form.Label>
      )}
      <Select
        className={`${isOpen ? 'border-on ' : ''} ${isArial ? 'full-arial' : ''}`}
        placeholder="Buscar..."
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => {
          if (setFieldTouched) setFieldTouched();
          setIsOpen(false);
        }}
        loadingMessage={() => 'Cargando...'}
        noOptionsMessage={() => noOptionsMessage}
        options={options}
        isSearchable
        name={name}
        value={value}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
        {...props}
      />
      {error && touched && <Form.Text className="text-danger">{error}</Form.Text>}
      {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
    </Form.Group>
  );
};

FormikSelectClear.propTypes = {
  delayHide: PropTypes.number,
  delayShow: PropTypes.number,
  direction: PropTypes.string,
  margin: PropTypes.string,
  toolbarVariant: PropTypes.string,
  tooltipText: PropTypes.string,
  labelClass: PropTypes.string,
  noOptionsMessage: PropTypes.string
};

FormikSelectClear.defaultProps = {
  delayHide: 0,
  delayShow: 250,
  direction: 'bottom',
  margin: '',
  toolbarVariant: '',
  tooltipText: '',
  labelClass: '',
  noOptionsMessage: 'No hay opciones'
};

export default FormikSelectClear;
